import { BuilderEmptyStateView } from '@/components/Common/BuilderEmptyStateView';
import { Box, Skeleton, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';

export default function BusinessInsightsSkeleton() {
  const theme = useTheme();

  return (
    <>
      <Grid container spacing={3}>
        {[1, 2, 3, 4].map((idx) => (
          <Grid key={`skeleton-card-${idx}`} size={{ xs: 12, sm: 6, md: 3 }}>
            <Box
              bgcolor='#fff'
              border='1px solid #ECECEC'
              p={2}
              borderRadius={2}
              borderLeft={`3px solid ${theme.palette.primary.main}`}
              minHeight={120}
            >
              <Box display='flex' justifyContent='space-between' alignItems='center' mb={1}>
                <Skeleton variant='text' width={80} height={20} />
                <Skeleton variant='circular' width={32} height={32} />
              </Box>
              <Skeleton variant='text' width={60} height={36} />
              <Skeleton variant='text' width={100} height={16} sx={{ mt: 1 }} />
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={2} mt={3}>
        <Skeleton variant='text' width={200} height={28} sx={{ mb: 2 }} />
        <Skeleton variant='rectangular' width='100%' height={240} sx={{ borderRadius: 1 }} />
      </Box>

      <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={2} mt={3}>
        <Skeleton variant='text' width={320} height={28} sx={{ mb: 2 }} />
        <Skeleton variant='rectangular' width='100%' height={320} sx={{ borderRadius: 1 }} />
      </Box>

      <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={2} mt={3}>
        <Skeleton variant='text' width={220} height={28} sx={{ mb: 1 }} />
        <Skeleton variant='text' width={360} height={20} sx={{ mb: 2 }} />
        <Skeleton variant='rectangular' width='100%' height={280} sx={{ borderRadius: 1 }} />
      </Box>
    </>
  );
}

export function BusinessInsightsError() {
  return (
    <Box
      bgcolor='#fff'
      border='1px solid #ECECEC'
      borderRadius={2}
      p={4}
      mt={2}
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <BuilderEmptyStateView message='No insights found.' />
    </Box>
  );
}
